import * as documentations from 'serviceWorker/db/documentations/documentations';
import { DocumentationEntity } from 'serviceWorker/repository/documentation/entity';

export async function getDocumentations(
  ids: number[]
): Promise<DocumentationEntity[]> {
  return documentations.getByIds(ids);
}
